/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { useUnstyled as i, uGrid as m, classNames as a } from "@progress/kendo-react-common";
import * as n from "react";
import { GridColumnMenuWrapper as s } from "../columnMenu/GridColumnMenuWrapper.mjs";
const o = (e) => {
  const l = i(), r = l && l.uGrid ? l.uGrid : m, c = e.onClick ? {
    onClick: e.onClick
  } : {}, t = /* @__PURE__ */ n.createElement("span", { className: a(r.headerCellInner({})) }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: a(
        r.headerCellLink({
          sortable: e.columnMenuWrapperProps.sortable
        })
      ),
      ...c
    },
    /* @__PURE__ */ n.createElement("span", { className: a(r.columnTitle({})) }, e.title || e.field || " "),
    e.children
  ), e.columnMenuWrapperProps.columnMenu && /* @__PURE__ */ n.createElement(s, { ...e.columnMenuWrapperProps }));
  return e.render ? e.render.call(void 0, t, e) : t;
};
export {
  o as GridHeaderCell
};
